module.exports = __webpack_public_path__ + "static/img/mobile-01-img@w.82b6a26.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/db-life-smart-phone-sales/mobile-01-img@w.png
// module id = lp/L
// module chunks = 0